import { z } from 'zod';
import { isoDateTimeSchema, uuidSchema } from './common.js';
import { timerStatusSchema } from './enums.js';
/**
 * Timers run on the device; the server copy exists so a timer survives a reload
 * and can be shown on another device of the same user.
 */
export const timerSchema = z.object({
    id: uuidSchema,
    recipeId: uuidSchema.nullable(),
    stepId: uuidSchema.nullable(),
    label: z.string(),
    durationSeconds: z.number().int().positive(),
    startedAt: isoDateTimeSchema,
    endsAt: isoDateTimeSchema.nullable(),
    remainingSeconds: z.number().int().nullable(),
    status: timerStatusSchema,
});
export const timerWriteSchema = z.object({
    recipeId: uuidSchema.nullable().optional(),
    stepId: uuidSchema.nullable().optional(),
    label: z.string().trim().min(1).max(120),
    durationSeconds: z
        .number()
        .int()
        .min(1)
        .max(60 * 60 * 24),
});
export const timerActionSchema = z.object({
    action: z.enum(['pause', 'resume', 'cancel', 'complete', 'add']),
    addSeconds: z.number().int().min(1).max(3600).optional(),
});
//# sourceMappingURL=timers.js.map